import React,{useState,useEffect} from 'react';
import styled from '@emotion/styled';
import { Link, useLocation } from 'react-router-dom';
import Hero from '../header/Hero';
import Featured from '../featured/Featured';
import { OrderGuide } from '../order-guide/OrderGuide.js';
import LearningCenter from '../learning-center/LearningCenter';
import MeetTheTeam from '../team/MeetTheTeam.js';
import ClientReview from '../reviews/ClientReview.js';
import LoadingComponent from '../shared/LoadingComponent';
import OverlayComponent from '../shared/OverlayComponent';
import { PrescriptionGuide } from '../order-guide/PrescriptionGuide';


const HomeWrapper = styled.div`
    width: 72rem;

    .featured{
        position:relative;
        width:inherit;

        h1{
            display: none;
        }
    }

    .featured > .cardGradient{
        position:absolute;
        right: -0rem;
        width: 46px;
        height: 481px;
        /* left: 1196px; */
        top: 208px;
        z-index:2;
        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    .featured > .cardGradient--second{
        position:absolute;
        width: 46px;
        height: 480px;
        left: -2rem;
        /* left: 1196px; */
        top: 208px;
        z-index:2;
        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    @media (max-width: 800px){
        width: inherit;
    }
    @media (max-width: 500px){
        .featured{
            /* left: -2rem;
            padding-left: 0.5rem; */
            h1{
                width: auto;
                z-index: 1;
                padding-top: 2rem;
                position: absolute;
                display: flex;
                font-family: Inter,sans-serif;
                font-size: var(--font-22);
                font-weight: 600;
                color: var(--company-dark);
            }
        }
       
    }
`;

const BottomGradient = styled.img`
    /* background-image: url('/page-decor/products-gradient.png'); */
    /* background-repeat: no-repeat;
    position: absolute; */
    position: absolute;
    z-index: 0;
    height: 40vh;
    display: flex;
    bottom: -5rem;
    width: 500%;
    margin-left: -200%;

    @media (width: 1440px){
        transform: translateX(-128px);
    }
`;

function Home() {
    const location = useLocation();
    const [display,setDisplay] = useState(false);
    const [item,setItem] = useState({
        product:'',
        image:"",
        media:""
    });
    const [loading,setLoading] = useState(true);
    useEffect(()=>{
        let isSubscribed = true;
        window.scrollTo(0, 0);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
        return () => (isSubscribed = false)
    },[loading])
        return (
            <>
                {loading ?
                <LoadingComponent/>
            :    
                <>
                    <OverlayComponent display={display} setDisplay={setDisplay} item={item}/>
                    <HomeWrapper>
                        <Hero /> 
                        <div className="featured">
                            <Featured style={{zIndex:"666"}} heading={"Explore Our Products"} text={"View All"} setDisplay={setDisplay} setItem={setItem}/>
                            <div className="cardGradient"></div>  
                            <div className="cardGradient--second"></div>  
                            <BottomGradient src="/page-decor/products-gradient.png"/>
                            {/* <Link to={"/products"}><h1>View All</h1></Link> */}
                        </div>
                        { location.state && location.state.page ? 
                            <OrderGuide />
                            :
                            <PrescriptionGuide/>
                        }
                        
                        {/* <LearningCenter /> */}
                        <MeetTheTeam />
                        <ClientReview />
                    </HomeWrapper>
                </>
            }
            </>
        )
    
}

export default Home;
